import { getErrors, setErrors, relocatedError, ERROR_SYMBOL } from '@graphql-tools/utils';
import { OBJECT_SUBSCHEMA_SYMBOL } from './symbols';
import { getSubschema, setObjectSubschema } from './Subschema';
import { defaultMergedResolver } from './defaultMergedResolver';
import { handleNull } from './results/handleNull';
function unwrapResult(parent, path) {
    var newParent = parent;
    var pathLength = path.length;
    for (var i = 0; i < pathLength; i++) {
        var responseKey = path[i];
        var errors = getErrors(newParent, responseKey);
        var subschema = getSubschema(newParent, responseKey);
        var object = newParent[responseKey];
        if (object == null) {
            return handleNull(errors);
        }
        setErrors(object, errors.map(function (error) { return relocatedError(error, error.path != null ? error.path.slice(1) : undefined); }));
        setObjectSubschema(object, subschema);
        newParent = object;
    }
    return newParent;
}
function dehoistResult(parent, delimeter) {
    if (delimeter === void 0) { delimeter = '__gqltf__'; }
    var result = Object.create(null);
    Object.keys(parent).forEach(function (alias) {
        var obj = result;
        var fieldNames = alias.split(delimeter);
        var fieldName = fieldNames.pop();
        fieldNames.forEach(function (key) {
            obj = obj[key] = obj[key] || Object.create(null);
        });
        obj[fieldName] = parent[alias];
    });
    result[ERROR_SYMBOL] = parent[ERROR_SYMBOL].map(function (error) {
        if (error.path != null) {
            var path = error.path.slice();
            var pathSegment = path.shift();
            var expandedPathSegment = pathSegment.split(delimeter);
            return relocatedError(error, expandedPathSegment.concat(path));
        }
        return error;
    });
    result[OBJECT_SUBSCHEMA_SYMBOL] = parent[OBJECT_SUBSCHEMA_SYMBOL];
    return result;
}
export function createMergedResolver(_a) {
    var fromPath = _a.fromPath, dehoist = _a.dehoist, _b = _a.delimeter, delimeter = _b === void 0 ? '__gqltf__' : _b;
    var parentErrorResolver = function (parent, args, context, info) {
        return parent instanceof Error ? parent : defaultMergedResolver(parent, args, context, info);
    };
    var unwrappingResolver = fromPath != null
        ? function (parent, args, context, info) { return parentErrorResolver(unwrapResult(parent, fromPath), args, context, info); }
        : parentErrorResolver;
    var dehoistingResolver = dehoist
        ? function (parent, args, context, info) { return unwrappingResolver(dehoistResult(parent, delimeter), args, context, info); }
        : unwrappingResolver;
    var noParentResolver = function (parent, args, context, info) {
        return parent ? dehoistingResolver(parent, args, context, info) : {};
    };
    return noParentResolver;
}
//# sourceMappingURL=createMergedResolver.js.map